import { useEffect, useState } from "react";
import type { ImgHTMLAttributes } from "react";
import imageFallback from "../assets/images/image-fallback.svg";

export { imageFallback };

type AppImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src?: string | null;
  fallbackSrc?: string;
};

const AppImage = ({
  src,
  fallbackSrc = imageFallback,
  alt = "",
  onError,
  ...props
}: AppImageProps) => {
  const [currentSrc, setCurrentSrc] = useState(src || fallbackSrc);

  useEffect(() => {
    setCurrentSrc(src || fallbackSrc);
  }, [src, fallbackSrc]);

  const handleError: ImgHTMLAttributes<HTMLImageElement>["onError"] = (
    event,
  ) => {
    if (currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
    }

    onError?.(event);
  };

  return (
    <img
      {...props}
      src={currentSrc}
      alt={alt}
      onError={handleError}
    />
  );
};

export default AppImage;
